import EventManager from 'services/timer/event-manager';
/**
 * @param {Object} - timer configuration { autoplay, step, id, time }.
 * @return {Timer} Timer object.
 */
class Timer {
  constructor(timerConfig) {
    const { autoplay, step, id, time, startTime, stoppedTime } = timerConfig || {};
    this.timerStates = {
      stopped: 'STOPPED',
      ticking: 'TICKING',
    };
    this.id = id || Math.random().toString(36).substring(7);
    this.autoplay = autoplay != null ? autoplay : true;
    this.time = parseInt(time) || 0;
    this.step = step ? step : 1;
    this.startTime = startTime ? new Date(startTime) : undefined;
    this.stoppedTime = stoppedTime ? new Date(stoppedTime) : undefined;
    this.setState(this.timerStates.stopped);
    if (this.autoplay) {
      this.startTime ? this.resume() : this.start();
    }
  }
  start() {
    if (this.intervalId) {
      console.log('Timer: Already started timer');
      return;
    }
    if (this.startTime) {
      return this.resume();
    }
    this.startTime = new Date();
    this.intervalId = setInterval(() => this.tick(), this.step * 1000);
    this.setState(this.timerStates.ticking);
    return this;
  }
  tick() {
    this.time++;
  }
  stop() {
    if (this.state === this.timerStates.stopped) {
      return this;
    }
    clearInterval(this.intervalId);
    this.intervalId = null;
    this.stoppedTime = new Date();
    this.setState(this.timerStates.stopped);
    return this;
  }
  resume() {
    if (!this.startTime) {
      return this.start();
    }
    this.intervalId = setInterval(() => this.tick(), this.step * 1000);
    this.setState(this.timerStates.ticking);
    return this;
  }
  reset() {
    this.startTime = null;
    this.time = 0;
    return this.stop();
  }
  getCurrentTime() {
    return this.time;
  }
  getCurrentState() {
    return this.state;
  }
  setState(state) {
    this.state = state;
  }
}

function withEvents(eventManager) {
  this.tickCount = 0;
  this.eventManager = eventManager;
  this.on = this.eventManager.on;
  this.off = this.eventManager.off;
  this.trigger = this.eventManager.trigger;
  this.superTick = this.tick;
  this.superSetState = this.setState;

  this.tick = function () {
    this.superTick();
    this.tickCount++;
    if (this.tickCount === this.tickEventPeriod) {
      this.trigger && this.trigger('tick');
      this.tickCount = 0;
    }
  };
  // Time to wait to trigger the tick event this is relevant when you want to perform an action every x seconds.
  this.setTickEventPeriod = function (eventPeriod) {
    this.tickEventPeriod = eventPeriod;
    return this;
  };
  this.setState = function (state) {
    this.superSetState(state);
    this.trigger && this.trigger(state.toLowerCase());
  };
  return this;
}

class TimerWithEvents extends Timer {
  constructor(config) {
    const { eventPrefix = 'timer' } = config;
    super(config);
    withEvents.bind(this)(new EventManager(eventPrefix));
  }
}

export { withEvents, TimerWithEvents };

export default Timer;
